import { render, staticRenderFns } from "./MpOverlay.vue?vue&type=template&id=0863c144"
import script from "./MpOverlay.vue?vue&type=script&lang=js"
export * from "./MpOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports